







import Vue from 'vue';
import Copyright from '@/components/Copyright.vue';

export default Vue.extend({
    components: {
        Copyright,
    }
})
